/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  WithAdminHold,
  WithAdminHoldOptional,
  WithAdminHoldMetaI,
  WithAdminHoldTrackedI,
} from "./with-admin-hold";
import { WithAdminHoldTracked, WithAdminHoldMeta } from "./with-admin-hold";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithAllowMultiple,
  WithAllowMultipleOptional,
  WithAllowMultipleMetaI,
  WithAllowMultipleTrackedI,
} from "./with-allow-multiple";
import {
  WithAllowMultipleTracked,
  WithAllowMultipleMeta,
} from "./with-allow-multiple";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithCancelledDatetime,
  WithCancelledDatetimeOptional,
  WithCancelledDatetimeMetaI,
  WithCancelledDatetimeTrackedI,
} from "./with-cancelled-datetime";
import {
  WithCancelledDatetimeTracked,
  WithCancelledDatetimeMeta,
} from "./with-cancelled-datetime";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithConfirmTemplate,
  WithConfirmTemplateOptional,
  WithConfirmTemplateMetaI,
  WithConfirmTemplateTrackedI,
} from "./with-confirm-template";
import {
  WithConfirmTemplateTracked,
  WithConfirmTemplateMeta,
} from "./with-confirm-template";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithNoLimit,
  WithNoLimitOptional,
  WithNoLimitMetaI,
  WithNoLimitTrackedI,
} from "./with-no-limit";
import { WithNoLimitTracked, WithNoLimitMeta } from "./with-no-limit";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithNoSignup,
  WithNoSignupOptional,
  WithNoSignupMetaI,
  WithNoSignupTrackedI,
} from "./with-no-signup";
import { WithNoSignupTracked, WithNoSignupMeta } from "./with-no-signup";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithSessionCt,
  WithSessionCtOptional,
  WithSessionCtMetaI,
  WithSessionCtTrackedI,
} from "./with-session-ct";
import { WithSessionCtTracked, WithSessionCtMeta } from "./with-session-ct";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithSessionLength,
  WithSessionLengthOptional,
  WithSessionLengthMetaI,
  WithSessionLengthTrackedI,
} from "./with-session-length";
import {
  WithSessionLengthTracked,
  WithSessionLengthMeta,
} from "./with-session-length";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithSignupMax,
  WithSignupMaxOptional,
  WithSignupMaxMetaI,
  WithSignupMaxTrackedI,
} from "./with-signup-max";
import { WithSignupMaxTracked, WithSignupMaxMeta } from "./with-signup-max";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithSignupMin,
  WithSignupMinOptional,
  WithSignupMinMetaI,
  WithSignupMinTrackedI,
} from "./with-signup-min";
import { WithSignupMinTracked, WithSignupMinMeta } from "./with-signup-min";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithTypeName,
  WithTypeNameOptional,
  WithTypeNameMetaI,
  WithTypeNameTrackedI,
} from "./with-type-name";
import { WithTypeNameTracked, WithTypeNameMeta } from "./with-type-name";

/**
 *
 * @export
 * @interface ClassTypeInfo
 */
export interface ClassTypeInfoOptional extends WithAdminHoldOptional {
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  sessionCt?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  sessionLength?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  signupMax?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  signupMin?: number;
  /**
   *
   * @type {string}
   * @memberof ClassTypeInfo
   */
  typeName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  adminHold?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  noLimit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  noSignup?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeInfo
   */
  cancelledDatetime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  allowMultiple?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeInfo
   */
  confirmTemplate?: string;
}

export interface ClassTypeInfo
  extends
    ClassTypeInfoOptional,
    WithAdminHold,
    WithAllowMultiple,
    WithCancelledDatetime,
    WithConfirmTemplate,
    WithNoLimit,
    WithNoSignup,
    WithSessionCt,
    WithSessionLength,
    WithSignupMax,
    WithSignupMin,
    WithTypeName {
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  sessionCt?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  sessionLength?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  signupMax?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  signupMin?: number;
  /**
   *
   * @type {string}
   * @memberof ClassTypeInfo
   */
  typeName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  adminHold?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  noLimit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  noSignup?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeInfo
   */
  cancelledDatetime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  allowMultiple?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeInfo
   */
  confirmTemplate?: string;
}

export interface ClassTypeInfoTrackedI extends WithAdminHoldOptional {
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  sessionCt?: number;
  sessionCtIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  sessionLength?: number;
  sessionLengthIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  signupMax?: number;
  signupMaxIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassTypeInfo
   */
  signupMin?: number;
  signupMinIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeInfo
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  adminHold?: boolean;
  adminHoldIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  noLimit?: boolean;
  noLimitIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  noSignup?: boolean;
  noSignupIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeInfo
   */
  cancelledDatetime?: Date;
  cancelledDatetimeIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeInfo
   */
  allowMultiple?: boolean;
  allowMultipleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeInfo
   */
  confirmTemplate?: string;
  confirmTemplateIsSet: boolean;
}

transformDatesMap.set("ClassTypeInfo", function (model: ClassTypeInfo) {
  if (typeof model.cancelledDatetime == "string")
    model.cancelledDatetime = new Date(model.cancelledDatetime);
});

export type ClassTypeInfoMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  sessionCt: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  sessionLength: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupMax: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupMin: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  adminHold: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  noLimit: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  noSignup: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  cancelledDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  allowMultiple: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  confirmTemplate: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ClassTypeInfoMeta: ClassTypeInfoMetaI = {} as ClassTypeInfoMetaI;
ClassTypeInfoMeta = typeMeta("ClassTypeInfo", {
  sessionCt: propertyMeta(
    "sessionCt",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  sessionLength: propertyMeta(
    "sessionLength",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  signupMax: propertyMeta(
    "signupMax",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  signupMin: propertyMeta(
    "signupMin",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
  adminHold: propertyMeta(
    "adminHold",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  noLimit: propertyMeta("noLimit", false, false, false, MetaTypesBase.boolean),
  noSignup: propertyMeta(
    "noSignup",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  cancelledDatetime: propertyMeta(
    "cancelledDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  allowMultiple: propertyMeta(
    "allowMultiple",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  confirmTemplate: propertyMeta(
    "confirmTemplate",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = ClassTypeInfoMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([WithSessionCtMeta]);
  metaI.sessionCt.inheritedFrom = WithSessionCtMeta.sessionCt;
  metaI.interfaces = metaI.interfaces.concat([WithSessionLengthMeta]);
  metaI.sessionLength.inheritedFrom = WithSessionLengthMeta.sessionLength;
  metaI.interfaces = metaI.interfaces.concat([WithSignupMaxMeta]);
  metaI.signupMax.inheritedFrom = WithSignupMaxMeta.signupMax;
  metaI.interfaces = metaI.interfaces.concat([WithSignupMinMeta]);
  metaI.signupMin.inheritedFrom = WithSignupMinMeta.signupMin;
  metaI.interfaces = metaI.interfaces.concat([WithTypeNameMeta]);
  metaI.typeName.inheritedFrom = WithTypeNameMeta.typeName;
  metaI.interfaces = metaI.interfaces.concat([WithAdminHoldMeta]);
  metaI.adminHold.inheritedFrom = WithAdminHoldMeta.adminHold;
  metaI.interfaces = metaI.interfaces.concat([WithNoLimitMeta]);
  metaI.noLimit.inheritedFrom = WithNoLimitMeta.noLimit;
  metaI.interfaces = metaI.interfaces.concat([WithNoSignupMeta]);
  metaI.noSignup.inheritedFrom = WithNoSignupMeta.noSignup;
  metaI.interfaces = metaI.interfaces.concat([WithCancelledDatetimeMeta]);
  metaI.cancelledDatetime.inheritedFrom =
    WithCancelledDatetimeMeta.cancelledDatetime;
  metaI.interfaces = metaI.interfaces.concat([WithAllowMultipleMeta]);
  metaI.allowMultiple.inheritedFrom = WithAllowMultipleMeta.allowMultiple;
  metaI.interfaces = metaI.interfaces.concat([WithConfirmTemplateMeta]);
  metaI.confirmTemplate.inheritedFrom = WithConfirmTemplateMeta.confirmTemplate;
});

export class ClassTypeInfoTracked
  extends WithAdminHoldTracked
  implements ClassTypeInfoTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  sessionCt__I?: number = undefined;
  sessionCtIsSet: boolean = false;
  set sessionCt(v: undefined | number) {
    if (v !== undefined) {
      this.sessionCt__I = v;
      this.sessionCtIsSet = true;
    } else {
      this.sessionCt__I = v || undefined;
      this.sessionCtIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionCt() {
    return this.sessionCt__I;
  }
  sessionLength__I?: number = undefined;
  sessionLengthIsSet: boolean = false;
  set sessionLength(v: undefined | number) {
    if (v !== undefined) {
      this.sessionLength__I = v;
      this.sessionLengthIsSet = true;
    } else {
      this.sessionLength__I = v || undefined;
      this.sessionLengthIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionLength() {
    return this.sessionLength__I;
  }
  signupMax__I?: number = undefined;
  signupMaxIsSet: boolean = false;
  set signupMax(v: undefined | number) {
    if (v !== undefined) {
      this.signupMax__I = v;
      this.signupMaxIsSet = true;
    } else {
      this.signupMax__I = v || undefined;
      this.signupMaxIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMax() {
    return this.signupMax__I;
  }
  signupMin__I?: number = undefined;
  signupMinIsSet: boolean = false;
  set signupMin(v: undefined | number) {
    if (v !== undefined) {
      this.signupMin__I = v;
      this.signupMinIsSet = true;
    } else {
      this.signupMin__I = v || undefined;
      this.signupMinIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMin() {
    return this.signupMin__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  adminHold__I?: boolean = undefined;
  adminHoldIsSet: boolean = false;
  set adminHold(v: undefined | boolean) {
    if (v !== undefined) {
      this.adminHold__I = v;
      this.adminHoldIsSet = true;
    } else {
      this.adminHold__I = v || undefined;
      this.adminHoldIsSet = false;
    }
    this.changeTracker = true;
  }
  get adminHold() {
    return this.adminHold__I;
  }
  noLimit__I?: boolean = undefined;
  noLimitIsSet: boolean = false;
  set noLimit(v: undefined | boolean) {
    if (v !== undefined) {
      this.noLimit__I = v;
      this.noLimitIsSet = true;
    } else {
      this.noLimit__I = v || undefined;
      this.noLimitIsSet = false;
    }
    this.changeTracker = true;
  }
  get noLimit() {
    return this.noLimit__I;
  }
  noSignup__I?: boolean = undefined;
  noSignupIsSet: boolean = false;
  set noSignup(v: undefined | boolean) {
    if (v !== undefined) {
      this.noSignup__I = v;
      this.noSignupIsSet = true;
    } else {
      this.noSignup__I = v || undefined;
      this.noSignupIsSet = false;
    }
    this.changeTracker = true;
  }
  get noSignup() {
    return this.noSignup__I;
  }
  cancelledDatetime__I?: Date = undefined;
  cancelledDatetimeIsSet: boolean = false;
  set cancelledDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.cancelledDatetime__I = v;
      this.cancelledDatetimeIsSet = true;
    } else {
      this.cancelledDatetime__I = v || undefined;
      this.cancelledDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get cancelledDatetime() {
    return this.cancelledDatetime__I;
  }
  allowMultiple__I?: boolean = undefined;
  allowMultipleIsSet: boolean = false;
  set allowMultiple(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowMultiple__I = v;
      this.allowMultipleIsSet = true;
    } else {
      this.allowMultiple__I = v || undefined;
      this.allowMultipleIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowMultiple() {
    return this.allowMultiple__I;
  }
  confirmTemplate__I?: string = undefined;
  confirmTemplateIsSet: boolean = false;
  set confirmTemplate(v: undefined | string) {
    if (v !== undefined) {
      this.confirmTemplate__I = v;
      this.confirmTemplateIsSet = true;
    } else {
      this.confirmTemplate__I = v || undefined;
      this.confirmTemplateIsSet = false;
    }
    this.changeTracker = true;
  }
  get confirmTemplate() {
    return this.confirmTemplate__I;
  }
  constructor(config?: ClassTypeInfoOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ClassTypeInfoOptional,
    options?: AssignOptions,
  ): ClassTypeInfoTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.sessionCt && this.sessionCtApplyFilter(optionsRequired.filter)) {
      this.sessionCt = config.sessionCt;
      if (optionsRequired.unassign) this.sessionCtIsSet = false;
      else this.sessionCtIsSet = true;
    }
    if (
      config.sessionLength &&
      this.sessionLengthApplyFilter(optionsRequired.filter)
    ) {
      this.sessionLength = config.sessionLength;
      if (optionsRequired.unassign) this.sessionLengthIsSet = false;
      else this.sessionLengthIsSet = true;
    }
    if (config.signupMax && this.signupMaxApplyFilter(optionsRequired.filter)) {
      this.signupMax = config.signupMax;
      if (optionsRequired.unassign) this.signupMaxIsSet = false;
      else this.signupMaxIsSet = true;
    }
    if (config.signupMin && this.signupMinApplyFilter(optionsRequired.filter)) {
      this.signupMin = config.signupMin;
      if (optionsRequired.unassign) this.signupMinIsSet = false;
      else this.signupMinIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (config.adminHold && this.adminHoldApplyFilter(optionsRequired.filter)) {
      this.adminHold = config.adminHold;
      if (optionsRequired.unassign) this.adminHoldIsSet = false;
      else this.adminHoldIsSet = true;
    }
    if (config.noLimit && this.noLimitApplyFilter(optionsRequired.filter)) {
      this.noLimit = config.noLimit;
      if (optionsRequired.unassign) this.noLimitIsSet = false;
      else this.noLimitIsSet = true;
    }
    if (config.noSignup && this.noSignupApplyFilter(optionsRequired.filter)) {
      this.noSignup = config.noSignup;
      if (optionsRequired.unassign) this.noSignupIsSet = false;
      else this.noSignupIsSet = true;
    }
    if (
      config.cancelledDatetime &&
      this.cancelledDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.cancelledDatetime = config.cancelledDatetime;
      if (optionsRequired.unassign) this.cancelledDatetimeIsSet = false;
      else this.cancelledDatetimeIsSet = true;
    }
    if (
      config.allowMultiple &&
      this.allowMultipleApplyFilter(optionsRequired.filter)
    ) {
      this.allowMultiple = config.allowMultiple;
      if (optionsRequired.unassign) this.allowMultipleIsSet = false;
      else this.allowMultipleIsSet = true;
    }
    if (
      config.confirmTemplate &&
      this.confirmTemplateApplyFilter(optionsRequired.filter)
    ) {
      this.confirmTemplate = config.confirmTemplate;
      if (optionsRequired.unassign) this.confirmTemplateIsSet = false;
      else this.confirmTemplateIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassTypeInfoTrackedI {
    const cloned = {} as ClassTypeInfoTrackedI;
    if (
      this.sessionCtIsSetDeep() &&
      this.sessionCtApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionCtIsSet = true;
      cloned.sessionCt = this.sessionCt;
    } else {
      //cloned.sessionCtIsSet = false
    }
    if (
      this.sessionLengthIsSetDeep() &&
      this.sessionLengthApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionLengthIsSet = true;
      cloned.sessionLength = this.sessionLength;
    } else {
      //cloned.sessionLengthIsSet = false
    }
    if (
      this.signupMaxIsSetDeep() &&
      this.signupMaxApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMaxIsSet = true;
      cloned.signupMax = this.signupMax;
    } else {
      //cloned.signupMaxIsSet = false
    }
    if (
      this.signupMinIsSetDeep() &&
      this.signupMinApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMinIsSet = true;
      cloned.signupMin = this.signupMin;
    } else {
      //cloned.signupMinIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.adminHoldIsSetDeep() &&
      this.adminHoldApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.adminHoldIsSet = true;
      cloned.adminHold = this.adminHold;
    } else {
      //cloned.adminHoldIsSet = false
    }
    if (
      this.noLimitIsSetDeep() &&
      this.noLimitApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.noLimitIsSet = true;
      cloned.noLimit = this.noLimit;
    } else {
      //cloned.noLimitIsSet = false
    }
    if (
      this.noSignupIsSetDeep() &&
      this.noSignupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.noSignupIsSet = true;
      cloned.noSignup = this.noSignup;
    } else {
      //cloned.noSignupIsSet = false
    }
    if (
      this.cancelledDatetimeIsSetDeep() &&
      this.cancelledDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cancelledDatetimeIsSet = true;
      cloned.cancelledDatetime = this.cancelledDatetime;
    } else {
      //cloned.cancelledDatetimeIsSet = false
    }
    if (
      this.allowMultipleIsSetDeep() &&
      this.allowMultipleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowMultipleIsSet = true;
      cloned.allowMultiple = this.allowMultiple;
    } else {
      //cloned.allowMultipleIsSet = false
    }
    if (
      this.confirmTemplateIsSetDeep() &&
      this.confirmTemplateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.confirmTemplateIsSet = true;
      cloned.confirmTemplate = this.confirmTemplate;
    } else {
      //cloned.confirmTemplateIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassTypeInfoTrackedI {
    if (!this.sessionCtApplyFilter(filter)) this.sessionCtIsSet = false;

    if (!this.sessionLengthApplyFilter(filter)) this.sessionLengthIsSet = false;

    if (!this.signupMaxApplyFilter(filter)) this.signupMaxIsSet = false;

    if (!this.signupMinApplyFilter(filter)) this.signupMinIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.adminHoldApplyFilter(filter)) this.adminHoldIsSet = false;

    if (!this.noLimitApplyFilter(filter)) this.noLimitIsSet = false;

    if (!this.noSignupApplyFilter(filter)) this.noSignupIsSet = false;

    if (!this.cancelledDatetimeApplyFilter(filter))
      this.cancelledDatetimeIsSet = false;

    if (!this.allowMultipleApplyFilter(filter)) this.allowMultipleIsSet = false;

    if (!this.confirmTemplateApplyFilter(filter))
      this.confirmTemplateIsSet = false;

    return this;
  }
  sessionCtApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.sessionCt,
      ClassTypeInfoMeta,
      this.sessionCt,
      this,
    );
  }
  sessionCtIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionCtIsSet && this.sessionCtApplyFilter(filter)) return true;

    return false;
  }
  sessionLengthApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.sessionLength,
      ClassTypeInfoMeta,
      this.sessionLength,
      this,
    );
  }
  sessionLengthIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionLengthIsSet && this.sessionLengthApplyFilter(filter))
      return true;

    return false;
  }
  signupMaxApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.signupMax,
      ClassTypeInfoMeta,
      this.signupMax,
      this,
    );
  }
  signupMaxIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMaxIsSet && this.signupMaxApplyFilter(filter)) return true;

    return false;
  }
  signupMinApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.signupMin,
      ClassTypeInfoMeta,
      this.signupMin,
      this,
    );
  }
  signupMinIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMinIsSet && this.signupMinApplyFilter(filter)) return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.typeName,
      ClassTypeInfoMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  adminHoldApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.adminHold,
      ClassTypeInfoMeta,
      this.adminHold,
      this,
    );
  }
  adminHoldIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.adminHoldIsSet && this.adminHoldApplyFilter(filter)) return true;

    return false;
  }
  noLimitApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.noLimit,
      ClassTypeInfoMeta,
      this.noLimit,
      this,
    );
  }
  noLimitIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.noLimitIsSet && this.noLimitApplyFilter(filter)) return true;

    return false;
  }
  noSignupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.noSignup,
      ClassTypeInfoMeta,
      this.noSignup,
      this,
    );
  }
  noSignupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.noSignupIsSet && this.noSignupApplyFilter(filter)) return true;

    return false;
  }
  cancelledDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.cancelledDatetime,
      ClassTypeInfoMeta,
      this.cancelledDatetime,
      this,
    );
  }
  cancelledDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cancelledDatetimeIsSet &&
      this.cancelledDatetimeApplyFilter(filter)
    )
      return true;

    return false;
  }
  allowMultipleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.allowMultiple,
      ClassTypeInfoMeta,
      this.allowMultiple,
      this,
    );
  }
  allowMultipleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowMultipleIsSet && this.allowMultipleApplyFilter(filter))
      return true;

    return false;
  }
  confirmTemplateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeInfoMeta.confirmTemplate,
      ClassTypeInfoMeta,
      this.confirmTemplate,
      this,
    );
  }
  confirmTemplateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.confirmTemplateIsSet && this.confirmTemplateApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.sessionCtIsSetDeep(filter)) return true;
    if (this.sessionLengthIsSetDeep(filter)) return true;
    if (this.signupMaxIsSetDeep(filter)) return true;
    if (this.signupMinIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.adminHoldIsSetDeep(filter)) return true;
    if (this.noLimitIsSetDeep(filter)) return true;
    if (this.noSignupIsSetDeep(filter)) return true;
    if (this.cancelledDatetimeIsSetDeep(filter)) return true;
    if (this.allowMultipleIsSetDeep(filter)) return true;
    if (this.confirmTemplateIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
